import React from "react";

export class NetworkError extends React.Component {
    render() {
        return <div className="overlay as-table">
            <div className="as-table-cell-center">
                <div className="error-message">
                    <span className="icon ico-alert  text-large"></span>
                    <span className="text-large text-bold">
                        Greška u komunikaciji
                              </span>
                </div>
                <div className="text-left as-inline-block margin-top">
                    <div className="info-message margin-top">
                        <span className="icon ico-info"></span>
                        <span>
                            Provjerite stanje internet veze
                              </span>
                    </div>
                    <div className="info-message">
                        <span className="icon ico-info"></span>
                        <span>
                            Osvježite stranicu
                              </span>
                    </div>

                    <button className="btn fill blue large margin-top as-block" onClick={() => location.reload()}>
                        <span>Osvježi stranicu</span>
                    </button>

                </div>
            </div>
        </div>
    }
};
